const getQuestionKey = (question) => question.question_key || question.key;

export const hasMeaningfulResponse = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (value && typeof value === 'object') {
    return Object.values(value).some(hasMeaningfulResponse);
  }
  return value !== undefined && value !== null && value !== '';
};

export const buildTopicRecommendations = ({ questions = [], responses = {}, topicLinks = [] }) => {
  const questionByKey = {};
  questions.forEach((question) => {
    questionByKey[getQuestionKey(question)] = question;
  });

  const seenTopicIds = new Set();
  const recommendations = [];

  topicLinks.forEach((link) => {
    const question = questionByKey[link.question_key];
    if (!question || !link.topic || seenTopicIds.has(link.topic.id)) return;

    const responseValue = responses[question.id];
    if (!hasMeaningfulResponse(responseValue)) return;

    recommendations.push({
      ...link.topic,
      reason: link.immediate_context || link.topic.why_we_are_asking || link.topic.short_summary,
      context_label: link.context_label,
      source_question_key: link.question_key
    });
    seenTopicIds.add(link.topic.id);
  });

  return recommendations;
};
